// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"aaefd020","2149":"aaefd020"}[chunkId] + ".chunk.css";
};